module.exports = __webpack_public_path__ + "img/styles_background_desktop@2x.3b36444.webp";